import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import HowItWorks from "@/components/site/HowItWorks";
import About from "@/components/site/About";
import ServiceArea from "@/components/site/ServiceArea";
import BookingForm from "@/components/site/BookingForm";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
    return (
        <main data-testid="home-page" className="bg-[#fdfdfd] text-[#0a0a0a]">
            <Navbar />
            <Hero />
            <TrustStrip />
            <Marquee />
            <Services />
            <HowItWorks />
            <About />
            <ServiceArea />
            <BookingForm />
            <Contact />
            <Footer />
        </main>
    );
}
